// extracted by mini-css-extract-plugin
module.exports = {"SPFieldDateTimeContainer":"SPFieldDateTimeContainer_12XXR","SPFieldDateTime":"SPFieldDateTime_3qR5H","SPFieldDateTimeHour":"SPFieldDateTimeHour_2RNZQ"};